import { useState, useEffect } from "react";
import axios from "axios";
import config from "../../../config";
import {decodeJwt } from "../../../authentication/authModules";
import { useTranslation } from "react-i18next";
const API_TOKEN = config.MAP_MATCHING_API_TOKEN;
const API_URL = config.MAP_MATCHING_API_URL;

const ReportsData = () => {
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
    const token = localStorage.getItem("keycloak-token");
  let userId = null;
  if (token) {
    try {
      const tokenObject = decodeJwt(token);
      //console.log("Decoded Token:", token);
      userId = tokenObject?.sub || null; // Extract userId from token
    } catch (error) {
      console.error("Error decoding JWT:", error);
    }
  }
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await axios.get(`${API_URL}/reports/${userId}`, {
            headers: {
              'X-API-Key': API_TOKEN
            }
          });
        setData(response.data); // Save API data to state
        setLoading(false); // Data is loaded
      } catch (err) {
        setError(t("trajectories.wizard.reports.loadReportsError"));
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return { data, loading, error };
};

export default ReportsData;
